import { render, staticRenderFns } from "./collectsCard.vue?vue&type=template&id=e3dc96a0&scoped=true"
import script from "./collectsCard.vue?vue&type=script&lang=js"
export * from "./collectsCard.vue?vue&type=script&lang=js"
import style0 from "./collectsCard.vue?vue&type=style&index=0&id=e3dc96a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dc96a0",
  null
  
)

export default component.exports